/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNav_filters = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"BuyMobileNavRefineMenuFilters_filters">;
    readonly " $refType": "BuyMobileNav_filters";
}>;
export type BuyMobileNav_filters$data = BuyMobileNav_filters;
export type BuyMobileNav_filters$key = ReadonlyArray<{
    readonly " $data"?: BuyMobileNav_filters$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyMobileNav_filters">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "BuyMobileNav_filters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyMobileNavRefineMenuFilters_filters"
    }
  ],
  "type": "SearchBrowseFilter",
  "abstractKey": null
};
(node as any).hash = '0423fd0e7df01cec0682fdd8445c530a';
export default node;
